import Constant from './constant'
import router from '@/router'
import axios from 'axios'
import qs from 'qs'
import {Loading, Message} from 'element-ui';

let _axios = axios.create({
    baseURL: Constant.SERVER_BASE_URL,
    timeout: 30000,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-Custom-Header': 'HYC',
        'api-agent': process.env.VERSION||''
    },
    transformRequest: [function (data, headers) {
        return data;
    }],
    transformResponse: axios.defaults.transformResponse.concat(function (data) {
        return renameObjectKey(data, '.', '__') //转换数据对象的key，将.换成__
    }),
    auth: {},
    responseType: 'json',
    maxContentLength: 5000,
    validateStatus: function (status) {
        return status >= 200 && status < 300; // default
    },
    showLoading: true,
    showMessage: false
});

let loadingInstance = {}

_axios.interceptors.request.use(function (config) {
    if (config.showLoading) {
        loadingInstance = Loading.service({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
    }

    if (typeof config.params == 'object') {
        Object.keys(config.params).forEach(key => {
            if (key.indexOf('sort.dataField') !== -1 && typeof config.params[key] == 'string' && config.params[key].indexOf('__') !== -1) {
                config.params[key] = config.params[key].replace('__', '.')
            }
        })
    }

    return config;

}, function (error) {
    return Promise.reject(error);
});

_axios.interceptors.response.use(function (response) {
    if (response.config.showLoading) {
        loadingInstance.close()
    }

    //显示操作信息提示
    if (response.config.method === 'post' && response.config.showMessage) {
        let message = '操作成功', type = 'success'

        if (response.data.status === 'failure') {
            type = 'error'
            message = '操作失败！'
            try {
                message += '' + response.data.msgs.map(item => item.text).join(',')
            } catch (e) {
            }
        }

        Message({
            type: type,
            message: message
        })
    }
    if (process.env.NODE_ENV === 'development') {
        console.log('调用接口: %s,\n参数:%o,\n返回: ', response.config.url, response.config.params || response.config.data, response.data);
    }

    return response;
}, function (error) {
    try {
        console.log(error)
        loadingInstance.close()
    } catch (e) {
        console.log(e)
    }


    let message = '服务器请求操作失败！'

    if (error.response) {
        if (error.response.status === 401) {
            message = '请重新登录！'
            router.push('/logon')
        }
        if (error.response.status === 403) {
            message = '服务器请求操作受限！'
            router.push('/403')
        }
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.log(error.response.data);
        // console.log(error.response.status);
        // console.log(error.response.headers);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('错误信息', error.message);
    }

    Message.error({
        message
    })


    return Promise.reject(error);
});

let $http = {}

$http.get = function (path = '', config = {}, success, fail) {
    _axios.get(path, config)
        .then(res => {
            success && success(res)
        })
        .catch(error => {
            console.log(error)
        })
}
$http.post = function (path = '', data = {}, config = {}, success, fail) {
    if (!config.transformRequest) {
        config.transformRequest = [function (data, headers) {
            if (typeof data === 'string') return data

            return qs.stringify({
                data: JSON.stringify(renameObjectKey(data, '__', '.'))
            })
        }]
    }

    _axios.post(path, data, config)
        .then(res => {
            success && success(res)
        })
        .catch(error => {
            console.log(error)
        })
}

function renameObjectKey(obj, replaceWhat, replaceTo, isArray) {
    let reg = new RegExp(replaceWhat.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g');
    let output = isArray ? [] : {}

    for (let i in obj) {
        if (typeof obj[i] === 'object' && obj[i] !== null) {
            output[i.replace(reg, replaceTo)] = renameObjectKey(obj[i], replaceWhat, replaceTo, Array.isArray(obj[i]));
        } else {
            output[i.replace(reg, replaceTo)] = obj[i];
        }
    }

    return output
}

export default $http



// WEBPACK FOOTER //
// ./src/utils/xhr.base.js